import clsx from "clsx";
import { graphql } from "gatsby";
import React, { FC, useRef } from "react";

import { BottomPanel } from "./panels/bottom-panel";
import { TopPanel } from "./panels/top-panel";
import { ParallaxBannerVariants } from "./types";

export interface ParallaxBannerSectionProps extends Queries.ParallaxBannerSectionDataFragment {}

export const ParallaxBannerSection: FC<ParallaxBannerSectionProps> = ({
  backgroundImage,
  topTitle,
  topVariant: _topVariant,
  bottomTitle,
  bottomBody,
  bottomVariant: _bottomVariant,
  cta,
  showTopGradient,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const topVariant = (_topVariant as ParallaxBannerVariants) ?? ParallaxBannerVariants.Primary;
  const bottomVariant =
    (_bottomVariant as ParallaxBannerVariants) ?? ParallaxBannerVariants.Neutral;

  return (
    <div
      className="relative"
      style={{
        backgroundImage: `url("${backgroundImage?.url}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
      }}
    >
      {showTopGradient && (
        <div className="absolute h-full w-full">
          <div
            className={clsx(
              "sticky top-0 mt-[-1px] z-20 overflow-hidden h-[10vh] lg:h-[22vh]",
              "via-[40%] lg:via-[25%] bg-gradient-to-b to-transparent",
              topVariant === ParallaxBannerVariants.Neutral
                ? "from-neutral via-neutral"
                : "from-primary via-primary"
            )}
          />
        </div>
      )}
      <div className="flex flex-col overflow-hidden" ref={contentRef}>
        <TopPanel
          className="relative w-[90%] 3xl:w-[80%]"
          title={topTitle ?? ""}
          variant={topVariant}
        />

        <BottomPanel
          className="relative w-full mt-20 lg:mt-48 lg:w-[90%] md:mx-auto"
          title={bottomTitle ?? ""}
          body={bottomBody?.bottomBody ?? undefined}
          variant={bottomVariant}
          cta={cta ?? undefined}
        />
      </div>
    </div>
  );
};

export const query = graphql`
  fragment ParallaxBannerSectionData on ContentfulParallaxBannerSection {
    topTitle
    bottomTitle
    bottomBody {
      bottomBody
    }
    backgroundImage {
      url
    }
    showTopGradient
    topVariant
    bottomVariant
    cta {
      ...CtaData
    }
  }
`;
